module.exports = __webpack_public_path__ + "static/Kaizen_CorredorSudeste_Eliminando-709d478a49e0824c0b7b94a9c74cecb2.png";